import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import TableHeader from "../../../../components/Tables/TableHeader";
import { Table_Array } from "../../arrays/SchoolsFields";
import { Link } from "react-router-dom";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function TableOfViewSchools({ schools }) {
  const { logout } = StaffuseAuth();

  //-----------------------------Begin Sorting---------------------------------------------
  // Assuming the rest of your component is defined here
  const [sortField, setSortField] = useState("Rating"); // Default sort by 'Text'
  const [sortDirection, setSortDirection] = useState("desc"); // 'asc' or 'desc'

  // Function To sort table
  const sortArray = (schools, field, direction) => {
    return schools.sort((a, b) => {
      if (a[field] < b[field]) return direction === "asc" ? -1 : 1;
      if (a[field] > b[field]) return direction === "asc" ? 1 : -1;
      return 0;
    });
  };

  // Sort table when sortField or sortDirection changes
  const sortedschools = sortArray([...schools], sortField, sortDirection);

  // Function To handle header click
  const handleHeaderClick = (field) => {
    if (field === sortField) {
      // Toggle sort direction
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc"); // Default To ascending when changing sort field
    }
  };

  //-----------------------------Return---------------------------------------------

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "95%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        View Schools
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
              {Table_Array.map((prop) => {
                return (
                  <>{TableHeader(prop.Name, handleHeaderClick, prop.Field)}</>
                );
              })}
              <>
                {TableHeader(
                  "Hubspot ID",
                  handleHeaderClick,
                  "HubspotCompanyID"
                )}
              </>
              <>{TableHeader("Update", handleHeaderClick, "School_Name")}</>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedschools.map((school, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                    "& .MuiTableCell-root": {
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word", // Adjust padding here to make cells smaller
                    },
                  },
                }}
              >
                {Table_Array.map((prop) => (
                  <>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {school[prop.Field]}
                    </TableCell>
                  </>
                ))}
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {school.HubspotCompanyID}
                  </TableCell>
                </>

                {/* New TableCell for update action using Link */}
                <TableCell
                  align="left"
                  sx={{
                    padding: "8px",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  <Link
                    to={`/Staff/ViewSchool/${school._id}`}
                    target="_blank"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <button>View</button>
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default TableOfViewSchools;
